export default {
  mame: 'damageItem',
  props: {
    damage: {
      type: Object,
      required: true
    }
  }
}
